import colors from '@theme/colors';
import { scale } from '@utils/normalize';
import { StyleSheet, Platform } from 'react-native';

const styles = StyleSheet.create({
  backdrop: {
    backgroundColor: colors.overlay.backdrop,
    flex: 1,
    justifyContent: 'flex-end',
    ...(Platform.OS === 'web' && {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 1000,
    }),
  },
  crossPressable: {
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    paddingRight: scale(10),
    paddingVertical: scale(5),
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
      userSelect: 'none',
    }),
  },
  iconContainer: {
    backgroundColor: colors.secondary.softOrchid,
    borderRadius: scale(12),
    marginLeft: scale(20),
    padding: scale(2),
  },
  innerContainer: {
    backgroundColor: colors.neutral.cotton,
    borderTopEndRadius: scale(20),
    borderTopStartRadius: scale(20),
    paddingBottom: scale(20),
    paddingVertical: scale(15),
    width: '100%',
  },
  limitStyle: { marginLeft: scale(7) },
  modalIconStyle: { alignSelf: 'center', marginRight: scale(6) },
  rowStyle: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: scale(0),
  },
  subRow: { alignItems: 'center', flexDirection: 'row' },
  tooltipBannerContainerStyle: {
    backgroundColor: colors.neutral.mist,
    marginHorizontal: scale(15),
    marginTop: scale(11),
  },
  tooltipBannerIconContainerStyle: { justifyContent: 'center' },
  tooltipBannerTextStyle: { flex: 1, paddingLeft: scale(10) },
  witdrawLimitStyle: {
    marginLeft: scale(22),
    marginTop: scale(16),
  },
});

export default styles;
